import React, { useState,useEffect } from "react";
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import Grid from '@mui/material/Grid';
import Hidden from '@mui/material/Hidden';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import InputString from './InputString';
import useStyles from './Styles';
import {Owner,Item} from './Inc';
import {Tools} from './Tools';
import StoreImg from './StoreImg';
import Ajax from './Ajax';
import BottomButtons from './BottomButtons';
import RowData from './RowData';
import Toast from './Toast';
import Loading from './Loading';
import Title from './Title';
import ItemLabelIcon from './ItemLabelIcon';
import { Inc, ItemFreeLabelLengthMin, ItemFreeLabelLengthMax } from './Inc';
import noImage from './imgs/noimage_profile.png';
import AppBank from './AppBank';

interface Props {
	owner:Owner,
	bank:AppBank,
}

const ItemLabel = (props:Props)=> {
	Ajax.setEditorId( props.owner.owner_id );
	const classes = useStyles();

	const defItems:Item[] = [];
	const [states,setStates] = useState({
		items: defItems,
		freeLabel: "",
		updated: false,
		isLoading: false,
		toast: "",
		yesno: "",
	});

	const search = ()=>{
		setStates({...states,"isLoading":true});
		//console.log("sort/list");
		Ajax.send("item/labeled_list",{},(res:any)=>{
			//console.log("item/labeled_list",res);
			if( res.ok ){
				let freeLabel = "";
				//console.log(res.items);
				res.items.find( (item:Item)=>{
					if( Number(item.label_id)===9 ){
						//setStates({...states,freeLabel:states.freeLabel});
						freeLabel = item.label as string;
						return;
					}
				});
				//console.log("freeLabel:",freeLabel);
				props.bank.set("freeLabel",freeLabel);

				setStates({...states,items:res.items,freeLabel:freeLabel,isLoading:false,toast:"",yesno:"",updated:false});
			} else {
				setStates({...states,"isLoading":false});
			}
		});
	}

	const reset = (labelId:number)=>{
		setStates({...states,"isLoading":true});
		Ajax.send("item/reset_label",{label_id:labelId},(res:any)=>{
			if( res.ok ){
				search();
			} else {
				setStates({...states,"isLoading":false});
			}
		});
	}
	const closeToast = ()=>{
		setStates({...states,"toast":""});
	}
	const onChangeFreeLabel = (value:string)=>{
		setStates({...states,freeLabel:value,updated:true});
		props.bank.set("freeLabel",value);
	}

	useEffect( ()=>{
		if( props.owner.owner_id>0 ){
			search();
		}
	},[]);

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	if( states.isLoading ){
		return (
			<Loading isLoading={true}/>
		)
	}
	return (
		<div id="sort_items" className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={8} lg={9}>
					<Paper className={classes.paper}>
						<Title text="ラベル"/>
						<div style={{marginBottom:"2em"}}>
							商品をアピールするためにラベルがつけられます<br/>
							つけられる数に制限がありますので、ご都合に合わせて商品を選んで下さい<br/>
						</div>

						<Table>
							<TableHead>
								<TableRow>
									<TableCell className={classes.tableHeadNowrap} align='center'>ラベルの種類</TableCell>
									<TableCell className={classes.tableHeadNowrap} align='center'>商品</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
						{Inc.itemLabels.map( (label,index)=>{
							const assignedItems = states.items.filter( (item)=>{return Number(item.label_id)===label.id} );
							const key = "label"+index;
							return (
								<TableRow key={key}>
									<TableCell className={classes.tableCellNowrap} style={{verticalAlign:"middle",width:"9rem"}}>
										<div style={{color:'teal'}}>
											<ItemLabelIcon labelId={label.id} />
											<span style={{marginLeft:"0.5em"}}>{label.label}</span>
										</div>
										<div style={{fontSize:'90%',color:'#999999'}}>{label.max} 商品以内</div>
									</TableCell>
									<TableCell>
										{assignedItems.length>0 &&
										<div style={{marginBottom:'1rem'}}>
										{assignedItems.map( (item:any,index2:number)=>{
											const key = "item"+index2;
											return (
												<div className={classes.favTypeList} key={key} style={{display:'flex',alignItems:'center',gap:'1rem'}}>
													<Hidden smDown implementation="js">
													<div>
														<StoreImg owner_id={props.owner.owner_id} img_id={item.img_id} thumb={true} className="imgList"/>
													</div>
													</Hidden>
													<div>
														<div style={{marginBottom:'0.5em'}}><span className={classes.itemId}>ID:{item.item_id}</span></div>
														<div>{item.item_name}</div>
														{item.page_name!==null && item.page_name !== "" ? (
															<div className="with_page_name">{item.page_name}</div>
														):(
															<div className="with_page_name">　</div>
														)}
													</div>
													<Hidden smDown implementation="js">
													<span className={classes.favTypeListCountMiddle} style={{fontWeight:"normal",fontSize:"90%"}}>{Tools.colorLabel("item_status",item.status,item.status_label)}</span>
													</Hidden>
													<Hidden smUp implementation="js">
													<span className={classes.favTypeListCountTop} style={{fontWeight:"normal",fontSize:"90%"}}>{Tools.colorLabel("item_status",item.status,item.status_label)}</span>
													</Hidden>
												</div>
											)
										})}
										</div>
										}
										<div>
										{label.id===9 &&
											<div>
												<InputString label="フリーラベル" required={false} value={states.freeLabel} onChange={onChangeFreeLabel} helper={ItemFreeLabelLengthMin+'文字以上'+ItemFreeLabelLengthMax+'文字以内'} opt={{minLength:ItemFreeLabelLengthMin,maxLength:ItemFreeLabelLengthMax}}/>
											</div>
										}
											<Box sx={{display:'flex',justifyContent:'flex-end',alignItems:'center',gap:'0.25rem'}}>
												<Button
													variant="outlined"
													color="primary"
													size="small"
													to={"/label/"+label.id}
													sx={{width:{xs:'50%',sm:'auto'}}}
													disabled={label.id===9 && states.freeLabel===""}
													component={Link}
												>商品選択</Button>
												<Button
													variant="outlined"
													sx={{width:{xs:'50%',sm:'auto'}}}
													color="primary"
													size="small"
													onClick={()=>{
														reset(label.id);
													}}
													disabled={assignedItems.length===0}
												>リセット</Button>
											</Box>
										</div>
									</TableCell>
								</TableRow>
							);
						})}
							</TableBody>
						</Table>

					</Paper>
				</Grid>
				<Grid item xs={12} md={4} lg={3}>

				</Grid>
			</Grid>
			<Toast mes={states.toast} close={closeToast}/>
		</div>
	);
}

export default ItemLabel;
